import React, { FC, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { HEADER_HEIGHT, STICKY_BAR_HEIGHT } from './constants';

const ScrollContainer = styled.div`
  overflow-y: auto;
  height: calc(100vh - ${HEADER_HEIGHT}px - ${STICKY_BAR_HEIGHT}px);
  position: relative;
  scrollbar-gutter: stable;
`;

type InnerScrollerProps = {
  children: React.ReactNode;
  scrollToTopIndicator?: string;
};

export const InnerScroller: FC<InnerScrollerProps> = ({
  scrollToTopIndicator = '',
  children,
  ...props
}) => {
  const targetRef = useRef(null);
  const targetElement = targetRef.current as HTMLDivElement | null;

  useEffect(() => {
    if (targetElement) {
      targetElement.scrollTop = 0;
    }
  }, [scrollToTopIndicator, targetElement]);

  return (
    <ScrollContainer ref={targetRef} {...props}>
      {children}
    </ScrollContainer>
  );
};
